/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Last_Bill_TitleInputs */

const es_admin_billing_last_bill_title = /** @type {(inputs: Admin_Billing_Last_Bill_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última factura`)
};

const en_admin_billing_last_bill_title = /** @type {(inputs: Admin_Billing_Last_Bill_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last invoice`)
};

/**
* | output |
* | --- |
* | "Last invoice" |
*
* @param {Admin_Billing_Last_Bill_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_last_bill_title = /** @type {((inputs?: Admin_Billing_Last_Bill_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Last_Bill_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_last_bill_title(inputs)
	return en_admin_billing_last_bill_title(inputs)
});
export { admin_billing_last_bill_title as "admin.billing.last_bill.title" }